export default __webpack_public_path__ + "static/media/property_535.dda68a13.png";